'use strict';

export default {
    itemKbn : {
        bag: {code: 1, info: [
            'line_name', 'color', 'accesories', 'specification'
        ]},
        watch: {code: 2, info: [
            'face', 'koma_count', 'weight', 'movement', 'accesories'
        ]},
        jewely: {code: 3, info: [
            'stone_name', 'size', 'weight', 'accesories'
        ]},
        accessory: {code: 4, info: [
            'size', 'weight', 'accesories'
        ]},
        other: {code: 5, info: [
            'line_name', 'color', 'accesories', 'specification'
        ]},
    }
};

